export default [
  'Ruby',
  'Elixir',
  'Ocaml',
  'Javascript',
  'Haskell',
  'Elm',
  'Python',
  'Php',
  'Bash',
  'Golang',
  'Typescript',
  'Swift',
  'Objective-c',
  'Clojure',
  'Clojurescript',
  'Scala',
  'Java ',
  'C',
  'C#',
  '.Net',
  'Functional',

  'React',
  'Angular',
  'Ember',
  'Vue',
  'Rails',
  'Redux',
  'Node',
  'Flux',
  'Django',
  'D3',
  'Jupyter',
  'Apollo',
  'Flux',
  'Next.js',

  'Postgres',
  'Mysql',
  'Mongodb',
  'Redis',
  'Kafka',
  'Aws',
  'Terraform',
  'Google cloud',
  'Docker',
  'Kubernetes',
  'Graphql',
  'Cassandra',
  'Spark',
  'Elasticsearch',
  'Heroku',
  'Foundationdb',
  'Blockchain',

  'Machine learning',
  'Deep learning',
  'Natural language',
  'AI',

  'Devops',
  'Remote',
  'Contract',
  'Freelance'
];
